import { Component, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageService } from 'src/app/services/account/language.service';
import { StackedModalsService } from 'src/app/services/modal/stacked-modals.service';
import { PrivacyPolicyComponent } from 'src/app/components/modals/info/privacy-policy/privacy-policy.component';

@Component({
  standalone: true,
  selector: 'app-cookie-panel',
  templateUrl: './cookie-panel.component.html',
  styleUrls: ['./cookie-panel.component.scss'],
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CookiePanelComponent {
  @Output() accepted = new EventEmitter<void>();

  constructor(
    public languageService: LanguageService,
    private stackedModalsService: StackedModalsService
  ) {}

  openPrivacyPolicy(): void {
    this.stackedModalsService.openModal(PrivacyPolicyComponent, {
      panelClass: 'dialog-snap-to-fullscreen',
      autoFocus: false
    });
  }

  accept(): void {
    this.accepted.emit();
  }
}
